export default __webpack_public_path__ + "img/logo.dff6610d.png";